import styled from 'styled-components';
import UnstyledCard from '../../components/Card';

// Wrapper for Header inside Card and Icon Button
export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  button {
    margin-top: 45px;
    width: auto;
  }

  h1 {
    margin-bottom: 0;
    font-size: 1.5rem;
    font-weight: 600;
    position: relative;
    &.active {
      &::after {
        content: '';
        display: block;
        width: 50%;
        height: 3px;
        background-color: ${({ theme }) => theme.brand.title};
        margin-top: 8px;
        position: absolute;
        left: 25%;
        border-radius: 4px 4px 0 0;
      }
    }
  }

  a h1 {
    opacity: 0.5;
    &::after {
      content: '';
      display: block;
      width: 50%;
      height: 3px;
      background-color: ${({ theme }) => theme.brand.title};
      margin-top: 10px;
      position: absolute;
      left: 25%;
      border-radius: 4px 4px 0 0;
      opacity: 0;
    }
    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease-in-out;
      &::after {
        opacity: 1;
        margin-top: 8px;
        transition: opacity 0.2s ease-in-out;
      }
    }
  }
`;

export const Card = styled(UnstyledCard)`
  padding-top: 45px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  & > h3 {
    padding-top: 25px;
  }

  & > button {
    width: auto;
    margin-bottom: 15px;
  }

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}

  & > button {
    margin-bottom: 0;
  }
`;

export const HeadingTabs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  border-bottom: 1px solid #ccc;
  margin-bottom: 1.5rem;
  width: 100%;
  padding-bottom: 0.75rem;
`;
